export function utcDifferenceInDays(dateLeft: Date, dateRight: Date) {
  let utcDateLeft = Date.UTC(
    dateLeft.getFullYear(),
    dateLeft.getMonth(),
    dateLeft.getDate(),
  );
  let utcDateRight = Date.UTC(
    dateRight.getFullYear(),
    dateRight.getMonth(),
    dateRight.getDate(),
  );

  const differenceInMilliseconds = Math.abs(utcDateLeft - utcDateRight);

  return Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
}
